import { Register } from "widgets/register"


export const RegisterPage = () => {
  return <Register />
}